import { cn } from "@discovery/classnames";
import { useEffect, useState } from "@discovery/common-dplus/lib/hooks";
import React from "react";
import { Icon, Icons } from "../../../../atoms/icon";
import { SquareLogoDesktopCard } from "./squareLogoDesktopCard";
import { SquareLogoMobileCard } from "./squareLogoMobileCard";
import styles from "./styles.css";
import { createRef } from "react";
const scrollableRail = createRef();
const SquareLogoCarousel = (props) => {
    const { cardData } = props;
    const swipeValue = 28.5;
    const [isLeftArrowVisible, setLeftArrow] = useState(false);
    const [isRightArrowVisible, setRighttArrow] = useState(false);
    const checkArrow = () => {
        const rail = scrollableRail.current;
        if (rail) {
            setLeftArrow(rail.scrollLeft > 0 ? true : false);
            setRighttArrow(rail.scrollWidth > rail.clientWidth &&
                rail.scrollWidth - rail.scrollLeft > rail.clientWidth
                ? true
                : false);
        }
    };
    const onLeftClick = () => {
        const rail = scrollableRail.current;
        if (rail) {
            const count = Math.floor(rail.clientWidth / swipeValue) - 1; //TODO-DPLUS: get card width dynamically
            rail.scrollTo({
                left: rail.scrollLeft - swipeValue * count,
                behavior: "smooth",
            });
        }
    };
    const onRightClick = () => {
        const rail = scrollableRail.current;
        if (rail) {
            const count = Math.floor(rail.clientWidth / swipeValue) - 1; //TODO-DPLUS: get card width dynamically
            rail &&
                rail.scrollTo({
                    left: rail.scrollLeft + swipeValue * count,
                    behavior: "smooth",
                });
        }
    };
    useEffect(() => {
        const rail = scrollableRail.current;
        rail && rail.addEventListener("scroll", checkArrow);
        checkArrow();
        return () => {
            rail && rail.removeEventListener("scroll", checkArrow);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const RenderLeftIcon = () => {
        return (React.createElement(Icon, { type: Icons.AngleLeftIcon, color: "#FFF", className: styles.arrowIcon }));
    };
    const RenderRightIcon = () => {
        return (React.createElement(Icon, { type: Icons.AngleRightIcon, color: "#FFF", className: styles.arrowIcon }));
    };
    return (React.createElement(React.Fragment, null, window.innerWidth <= 699 ? (cardData.map((item, index) => (React.createElement(SquareLogoMobileCard, Object.assign({}, item, { key: index, decoratorTheme: "" }))))) : (React.createElement("div", { className: cn(styles.railWrapper) },
        React.createElement("div", { className: cn(styles.arrow, styles.left), onClick: onLeftClick }, isLeftArrowVisible && React.createElement(RenderLeftIcon, null)),
        React.createElement("div", { className: styles.container, ref: scrollableRail }, cardData.map((item, index) => (React.createElement(SquareLogoDesktopCard, Object.assign({}, item, { key: index, decoratorTheme: "" }))))),
        React.createElement("div", { className: cn(styles.arrow, styles.right), onClick: onRightClick }, isRightArrowVisible && React.createElement(RenderRightIcon, null))))));
};
export default SquareLogoCarousel;

